export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.929c3.905-3.905 10.237-3.905 14.142 0 3.906 3.905 3.906 10.237 0 14.142-3.905 3.906-10.237 3.906-14.142 0-3.905-3.905-3.905-10.237 0-14.142zm2.167 13.389a7.999 7.999 0 0010.561-.66 7.999 7.999 0 00.66-10.562L7.097 18.318zm9.808-12.636a8 8 0 00-10.561.661 8 8 0 00-.661 10.56L16.904 5.683z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};